// extracted by mini-css-extract-plugin
export default {"header":"style_header__if9sn","title":"style_title__56g8v","deleteButton":"style_deleteButton__IZhZf"};